import React from 'react'
import { NavLink } from 'react-router-dom'
import { FiUsers, FiBell, FiSettings, FiTool, FiGrid, FiLogOut } from 'react-icons/fi'
import logo from '../../Assets/sanifrutta-logo.png'
import { canAccessRoute } from '../../Global/Config'

const NAV_ITEMS = [
  { path: '/', label: 'Dashboard', icon: FiGrid },
  { path: '/users', label: 'Utenti', icon: FiUsers },
  { path: '/notifications', label: 'Notifiche', icon: FiBell },
  { path: '/automations', label: 'Automazioni', icon: FiSettings },
  { path: '/maintenance', label: 'Manutenzioni', icon: FiTool }
]

export default function Sidebar ({ open, onClose, onLogout, userType }) {
  const items = NAV_ITEMS.filter(item => canAccessRoute(item.path, userType))

  return (
    <aside className={`admin-sidebar${open ? ' open' : ''}`}>
      <div className='admin-sidebar-logo'>
        <img src={logo} alt='Sanifrutta' />
      </div>
      <nav className='admin-sidebar-nav'>
        {items.map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) => `admin-sidebar-link${isActive ? ' active' : ''}`}
            onClick={onClose}
          >
            <item.icon />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
      <div className='admin-sidebar-footer'>
        <button className='admin-sidebar-logout' onClick={onLogout}>
          <FiLogOut />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  )
}
